export const RESET_EMAIL_OPEN_MODAL = "RESET_EMAIL_OPEN_MODAL";
export const RESET_EMAIL_CLOSE_MODAL = "RESET_EMAIL_CLOSE_MODAL";

export const RESET_EMAIL_REQUEST = "RESET_EMAIL_REQUEST";
export const RESET_EMAIL_RESULT = "RESET_EMAIL_RESULT";

